export enum ZygosityEnum {
  R2 = "R2",
  R3 = "R3",
}
